module.exports = {"231224001":"吉康街道","231224002":"庆瑞街道","231224003":"平顺街道","231224004":"安泰街道","231224101":"庆安镇","231224102":"民乐镇","231224103":"大罗镇","231224104":"平安镇","231224105":"勤劳镇","231224106":"久胜镇","231224107":"同乐镇","231224108":"柳河镇","231224201":"建民乡","231224202":"巨宝山乡","231224206":"丰收乡","231224208":"发展乡","231224210":"致富乡","231224211":"欢胜乡","231224400":"国有林场管理局","231224500":"柳河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231224.json
// module id = 795
// module chunks = 0